<iss-form-field [showNecessity]="showNecessity">
  <iss-label>{{ 'iss-wo-common.label.site' | translate }}</iss-label>
  <wo-site-input
    data-e2e="site"
    [formControl]="control.control"
    [readonly]="readonly"
    [loading]="loading"
    [forceTypeahead]="forceTypeahead"
    [withAll]="withAll"
    [customerIds]="customerIds"
    [available]="available"
    [role]="role"
    [country]="country"
    [placeholder]="placeholder"
    [siteStates]="siteStates"
    [multi]="multi"
    [clearable]="clearable"
  />
  <ng-template issFormFieldError let-errors>
    <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
  </ng-template>
</iss-form-field>
